import { Stack } from '@adc/parallax-component-library';
import { createFileRoute } from '@tanstack/react-router';

import { SignInForm } from '~/components/SignInForm';
import { publicRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/login')({
  component: RouteComponent,
  beforeLoad: publicRoute,
});

function RouteComponent() {
  return (
    <Stack
      flex={1}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      $xs={{ justifyContent: 'flex-start' }}
    >
      <Stack
        width="80%"
        maxWidth={700}
        padding="$6"
        backgroundColor="$surface.background"
        $xs={{ width: '100%' }}
      >
        <SignInForm />
      </Stack>
    </Stack>
  );
}
